import ClickLogger from '@/components/common/ClickLogger';
import { EWebDiagnosisInflowType } from '@/entities/diagnosis/libs/constants';
import { EDoctorsWithWebDiagnosisLog } from '@/widgets/doctors-with-web-diagnosis/lib/constants';
import { BottomSheet, Button } from 'doctornow-design-system';

interface Props {
  categoryName: string;
  isOpen: boolean;
  onNavigateToTelemedicine: () => void;
  onNavigateToNextQna: () => void;
  onClose: () => void;
}

const QnaRelatedBottomSheet = ({
  categoryName,
  isOpen,
  onNavigateToTelemedicine,
  onNavigateToNextQna,
  onClose,
}: Props) => {
  return (
    <BottomSheet
      type='vertical'
      title={'고민을 진료로 바로 해결할 수 있어요'}
      description={
        <>
          답변으로 궁금증이 완전히 해결되지 않는다면,
          <br />
          의사 선생님에게 직접 물어보세요.
        </>
      }
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
    >
      <div className='flex flex-col items-center justify-center gap-[32px] pb-[24px]'>
        <img
          src='https://media.doctornow.co.kr/telemedicine/bottom-sheet/web_diagnosis_bottom_sheet.webp'
          alt='qna-related-question-telemedicine'
          className='h-[153px] object-contain'
        />
        <div className='flex w-full flex-col gap-[12px]'>
          <ClickLogger
            params={{
              eventName: EDoctorsWithWebDiagnosisLog.ClickTelemedicineRequestBottomSheet,
              payload: {
                categoryName,
                inflowType: EWebDiagnosisInflowType.QnaRelatedQuestionBottomSheet,
              },
            }}
          >
            <Button
              buttonColor='primary'
              buttonStyle='contained'
              size='xl'
              onClick={() => {
                onClose();
                onNavigateToTelemedicine();
              }}
            >
              바로 진료 받기
            </Button>
          </ClickLogger>
          <ClickLogger
            params={{
              eventName: EDoctorsWithWebDiagnosisLog.ClickRelatedQnaBottomSheet,
              payload: {
                categoryName,
                inflowType: EWebDiagnosisInflowType.QnaRelatedQuestionBottomSheet,
              },
            }}
          >
            <Button
              buttonColor='gray'
              buttonStyle='outlined'
              size='xl'
              onClick={() => {
                onClose();
                onNavigateToNextQna();
              }}
            >
              다음 글 보기
            </Button>
          </ClickLogger>
        </div>
      </div>
    </BottomSheet>
  );
};

export default QnaRelatedBottomSheet;
